// src/Components/Auth/PrivateRoute.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  // 1. Not signed in → redirect to sign in
  if (!user || !user.email) {
    return <Navigate to="/signin" replace />;
  }

  // 2. Signed in but onboarding not completed → redirect to onboarding
  if (user.onboardingDone === false && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default PrivateRoute;
